import riot from 'riot';
import events from '../src/events.js';
import { getSensors as libGetSensors } from '../src/lib.js';
riot.tag2('sensors', '<div class="container is-fluid has-text-centered" show="{sensorsLoading}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="columns is-multiline" if="{!sensorsLoading}" style="margin-top: 5px;"> <div class="column is-4" each="{s in sensors}" if="{s.kit_type == \'base\' || s.kit_type == selectedDevice.kit_type}"> <sensor sensor="{s}" device="{selectedDevice}"></sensor> </div> </div>', '', '', function(opts) {
        var self = this;
        self.sensors = [];
        self.sensorsLoading = true;
        self.selectedDevice = undefined;

        self.on('mount', function() {
            getSensors();
        });

        events.on('select_device', function(payload) {
            const { selectedDevice } = payload || {};

            self.selectedDevice = selectedDevice;
        });

        events.on('sensor_refresh', function() {
            getSensors();
        })

        function getSensors() {
            self.sensorsLoading = true;
            libGetSensors().then(function(res) {
                self.sensorsLoading = false;
                localStorage.setItem("sensors", JSON.stringify(res['data']['sensors']));
                self.update({
                    sensors: res['data']['sensors'],
                    sensors_error: undefined
                });
                events.emit('sensors_loaded', res['data']['sensors']);
            }).catch(function(error) {
                console.error('Sensors Error:' + error);
                self.sensorsLoading = false;
                self.update({
                    sensors: [],
                    sensors_error: error
                });
            });
        }
});
